// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__ZMRjy","footer":"ModalFilter_footer__3QcZB"};